/**
 * Add global constants for the application
 */

export default {
  PLATFORM_CHARGES: 29.99,
};
